module.exports = __webpack_public_path__ + "app/heySpace/components/App/assets/newMessage.mp3";